// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import AuditsService from './admin/audits/audits.service';

// vue-select: https://vue-select.org/guide/install.html#yarn-npm
import vSelect from 'vue-select';
// import 'vue-select/dist/vue-select.css';

import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ActivateService from './account/activate/activate.service';
import RegisterService from './account/register/register.service';
import UserManagementService from '@/admin/user-management/user-management.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import '../content/scss/vendor.scss';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import ConfigurationService from '@/admin/configuration/configuration.service';

import MerchantUserService from '@/entities/merchant-user/merchant-user.service';
import MerchantService from '@/entities/merchant/merchant.service';
import MerchantDocumentService from '@/entities/merchant-document/merchant-document.service';
import DocumentService from '@/entities/document/document.service';
import ContentService from '@/entities/content/content.service';
import CategoryService from '@/entities/category/category.service';
import PlanService from '@/entities/plan/plan.service';
import MerchantPlanService from '@/entities/merchant-plan/merchant-plan.service';
import MerchantFollowersService from '@/entities/merchant-followers/merchant-followers.service';
import MerchantLocationEmployeeService from '@/entities/merchant-location-employee/merchant-location-employee.service';
import MerchantLocationService from '@/entities/merchant-location/merchant-location.service';
import MerchantPricePointRatioTrendService from '@/entities/merchant-price-point-ratio-trend/merchant-price-point-ratio-trend.service';
import MerchantPriceStampRatioTrendService from '@/entities/merchant-price-stamp-ratio-trend/merchant-price-stamp-ratio-trend.service';
import MerchantBarredService from '@/entities/merchant-barred/merchant-barred.service';
import MerchantEmployeeService from '@/entities/merchant-employee/merchant-employee.service';
import NonUniqueVoucherService from '@/entities/non-unique-voucher/non-unique-voucher.service';
import PointsOfferService from '@/entities/points-offer/points-offer.service';
import PointsOfferLocationService from '@/entities/points-offer-location/points-offer-location.service';
import PointsOfferViewRatingService from '@/entities/points-offer-view-rating/points-offer-view-rating.service';
import PaymentInvoiceService from '@/entities/payment-invoice/payment-invoice.service';
import PaymentHistoryService from '@/entities/payment-history/payment-history.service';
import PaymentSourceService from '@/entities/payment-source/payment-source.service';
import MerchantPaymentOptionService from '@/entities/merchant-payment-option/merchant-payment-option.service';
import MerchantDepositService from '@/entities/merchant-deposit/merchant-deposit.service';
import RefundHistoryService from '@/entities/refund-history/refund-history.service';
import PointsOfferTrendService from '@/entities/points-offer-trend/points-offer-trend.service';
import ShippableOfferService from '@/entities/shippable-offer/shippable-offer.service';
import StampsOfferService from '@/entities/stamps-offer/stamps-offer.service';
import StampsOfferLocationService from '@/entities/stamps-offer-location/stamps-offer-location.service';
import StampsOfferViewRatingService from '@/entities/stamps-offer-view-rating/stamps-offer-view-rating.service';
import StampsOfferTrendService from '@/entities/stamps-offer-trend/stamps-offer-trend.service';
import UniqueVoucherService from '@/entities/unique-voucher/unique-voucher.service';
import UniqueVoucherGeneratedService from '@/entities/unique-voucher-generated/unique-voucher-generated.service';
import MonthlyActiveUserService from '@/entities/monthly-active-user/monthly-active-user.service';
import MonthlyActiveUserCountService from '@/entities/monthly-active-user-count/monthly-active-user-count.service';
import UniqueVoucherLocationService from '@/entities/unique-voucher-location/unique-voucher-location.service';
import UniqueVoucherReviewRatingService from '@/entities/unique-voucher-review-rating/unique-voucher-review-rating.service';
import UserPointsBalanceService from '@/entities/user-points-balance/user-points-balance.service';
import UserPointsCollectionRequestService from '@/entities/user-points-collection-request/user-points-collection-request.service';
import UserPointsCollectionHistoryService from '@/entities/user-points-collection-history/user-points-collection-history.service';
import UserPointsRedemptionHistoryService from '@/entities/user-points-redemption-history/user-points-redemption-history.service';
import PointsOfferReviewRatingHistoryService from '@/entities/points-offer-review-rating-history/points-offer-review-rating-history.service';
import StampsOfferReviewRatingHistoryService from '@/entities/stamps-offer-review-rating-history/stamps-offer-review-rating-history.service';
import UniqueVoucherReviewRatingHistoryService from '@/entities/unique-voucher-review-rating-history/unique-voucher-review-rating-history.service';
import UserPointsRedemptionRequestService from '@/entities/user-points-redemption-request/user-points-redemption-request.service';
import UserStampsBalanceService from '@/entities/user-stamps-balance/user-stamps-balance.service';
import UserStampsCollectionHistoryService from '@/entities/user-stamps-collection-history/user-stamps-collection-history.service';
import UserStampsRedemptionHistoryService from '@/entities/user-stamps-redemption-history/user-stamps-redemption-history.service';
import InvitationTokenService from '@/entities/invitation-token/invitation-token.service';
import LoyaltyStorageService from '@/entities/loyalty-storage/loyalty-storage.service';
import MerchantAttachmentService from '@/entities/merchant-attachment/merchant-attachment.service';
import MerchantOfferAttachmentService from '@/entities/merchant-offer-attachment/merchant-offer-attachment.service';
import NotificationJobService from '@/entities/notification-job/notification-job.service';
import OfferChallengeService from '@/entities/offer-challenge/offer-challenge.service';
import OfferOcrChallengeService from '@/entities/offer-ocr-challenge/offer-ocr-challenge.service';
import OfferUniqueCodeService from '@/entities/offer-unique-code/offer-unique-code.service';
import StampsOfferViewRatingHistoryService from '@/entities/stamps-offer-view-rating-history/stamps-offer-view-rating-history.service';
import UniqueVoucherGeneratedHistoryService from '@/entities/unique-voucher-generated-history/unique-voucher-generated-history.service';
import UserRedemptionUniqueCodeService from '@/entities/user-redemption-unique-code/user-redemption-unique-code.service';
import UserStampsCollectionRequestService from '@/entities/user-stamps-collection-request/user-stamps-collection-request.service';
import UserStampsRedemptionRequestService from '@/entities/user-stamps-redemption-request/user-stamps-redemption-request.service';
import UserAddressService from '@/entities/user-address/user-address.service';
import ShippingLogisticService from '@/entities/shipping-logistic/shipping-logistic.service';
import CountryService from './entities/countries/countries.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

//custom service
import FileReaderService from '@/shared/service/file-reader.service';
import EmailService from '@/admin/email/email.service';
import EmailCampaignService from '@/admin/email-campaign/email-campaign.service';
import * as VueGoogleMaps from 'vue2-google-maps';

// Text editor for sending emails usage: REF: https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs.html#using-es6-modules
import CKEditor from '@ckeditor/ckeditor5-vue2';
import OfferChallengeProductService from './entities/offer-challenge-product/offer-challenge-product.service';

Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);

// add api key here and specify library
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDWvsz5VgJmvGeQftSUoz51dRc_NOQB7gM',
    libraries: 'places' //necessary for places input
  }
});

Vue.use(CKEditor);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('v-select', vSelect);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    if (!accountService.hasAnyAuthority(to.meta.authorities)) {
      sessionStorage.setItem('requested-url', to.fullPath);
      next('/forbidden');
    } else {
      next();
    }
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),

    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    merchantUserService: () => new MerchantUserService(),
    merchantService: () => new MerchantService(),
    merchantDocumentService: () => new MerchantDocumentService(),
    documentService: () => new DocumentService(),
    contentService: () => new ContentService(),
    categoryService: () => new CategoryService(),
    planService: () => new PlanService(),
    merchantPlanService: () => new MerchantPlanService(),
    merchantFollowersService: () => new MerchantFollowersService(),
    merchantLocationEmployeeService: () => new MerchantLocationEmployeeService(),
    merchantLocationService: () => new MerchantLocationService(),
    merchantPricePointRatioTrendService: () => new MerchantPricePointRatioTrendService(),
    merchantPriceStampRatioTrendService: () => new MerchantPriceStampRatioTrendService(),
    merchantBarredService: () => new MerchantBarredService(),
    merchantEmployeeService: () => new MerchantEmployeeService(),
    nonUniqueVoucherService: () => new NonUniqueVoucherService(),
    pointsOfferService: () => new PointsOfferService(),
    pointsOfferLocationService: () => new PointsOfferLocationService(),
    pointsOfferViewRatingService: () => new PointsOfferViewRatingService(),
    paymentInvoiceService: () => new PaymentInvoiceService(),
    paymentHistoryService: () => new PaymentHistoryService(),
    paymentSourceService: () => new PaymentSourceService(),
    merchantPaymentOptionService: () => new MerchantPaymentOptionService(),
    merchantDepositService: () => new MerchantDepositService(),
    refundHistoryService: () => new RefundHistoryService(),
    pointsOfferTrendService: () => new PointsOfferTrendService(),
    shippableOfferService: () => new ShippableOfferService(),
    stampsOfferService: () => new StampsOfferService(),
    stampsOfferLocationService: () => new StampsOfferLocationService(),
    stampsOfferViewRatingService: () => new StampsOfferViewRatingService(),
    stampsOfferTrendService: () => new StampsOfferTrendService(),
    uniqueVoucherService: () => new UniqueVoucherService(),
    uniqueVoucherGeneratedService: () => new UniqueVoucherGeneratedService(),
    monthlyActiveUserService: () => new MonthlyActiveUserService(),
    monthlyActiveUserCountService: () => new MonthlyActiveUserCountService(),
    uniqueVoucherLocationService: () => new UniqueVoucherLocationService(),
    uniqueVoucherReviewRatingService: () => new UniqueVoucherReviewRatingService(),
    userPointsBalanceService: () => new UserPointsBalanceService(),
    userPointsCollectionRequestService: () => new UserPointsCollectionRequestService(),
    userPointsCollectionHistoryService: () => new UserPointsCollectionHistoryService(),
    userPointsRedemptionHistoryService: () => new UserPointsRedemptionHistoryService(),
    pointsOfferReviewRatingHistoryService: () => new PointsOfferReviewRatingHistoryService(),
    stampsOfferReviewRatingHistoryService: () => new StampsOfferReviewRatingHistoryService(),
    uniqueVoucherReviewRatingHistoryService: () => new UniqueVoucherReviewRatingHistoryService(),
    userPointsRedemptionRequestService: () => new UserPointsRedemptionRequestService(),
    userStampsBalanceService: () => new UserStampsBalanceService(),
    userStampsCollectionHistoryService: () => new UserStampsCollectionHistoryService(),
    userStampsRedemptionHistoryService: () => new UserStampsRedemptionHistoryService(),
    invitationTokenService: () => new InvitationTokenService(),
    loyaltyStorageService: () => new LoyaltyStorageService(),
    merchantAttachmentService: () => new MerchantAttachmentService(),
    merchantOfferAttachmentService: () => new MerchantOfferAttachmentService(),
    notificationJobService: () => new NotificationJobService(),
    offerChallengeService: () => new OfferChallengeService(),
    offerOcrChallengeService: () => new OfferOcrChallengeService(),
    offerUniqueCodeService: () => new OfferUniqueCodeService(),
    stampsOfferViewRatingHistoryService: () => new StampsOfferViewRatingHistoryService(),
    uniqueVoucherGeneratedHistoryService: () => new UniqueVoucherGeneratedHistoryService(),
    userRedemptionUniqueCodeService: () => new UserRedemptionUniqueCodeService(),
    userStampsCollectionRequestService: () => new UserStampsCollectionRequestService(),
    userStampsRedemptionRequestService: () => new UserStampsRedemptionRequestService(),
    userAddressService: () => new UserAddressService(),
    shippingLogisticService: () => new ShippingLogisticService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    //custom service
    fileReaderService: () => new FileReaderService(),
    emailService: () => new EmailService(),
    emailCampaignService: () => new EmailCampaignService(),
    offerChallengeProductService: () => new OfferChallengeProductService(),
    countryService: () => new CountryService()
  },
  i18n,
  store
});
